const DOMAIN_TYPOS = {
  "gmial.com": "gmail.com", "gmal.com": "gmail.com", "gmaill.com": "gmail.com", "gamil.com": "gmail.com", "gnail.com": "gmail.com",
  "gmai.com": "gmail.com", "gmil.com": "gmail.com", "gmail.co": "gmail.com", "gmail.cm": "gmail.com", "gmail.om": "gmail.com",
  "googlemail.co": "googlemail.com", "hotmial.com": "hotmail.com", "hotmal.com": "hotmail.com", "hotmai.com": "hotmail.com",
  "hotmil.com": "hotmail.com", "homail.com": "hotmail.com", "hotmail.cm": "hotmail.com", "hotmial.co.uk": "hotmail.co.uk",
  "hotmail.co": "hotmail.co.uk", "outlok.com": "outlook.com", "outllok.com": "outlook.com", "outlook.co": "outlook.com",
  "outloook.com": "outlook.com", "yahooo.com": "yahoo.com", "yaho.com": "yahoo.com", "yahoo.cm": "yahoo.com", "yhoo.com": "yahoo.com",
  "yahoo.co": "yahoo.co.uk", "iclod.com": "icloud.com", "icloud.co": "icloud.com", "icoud.com": "icloud.com", "iclould.com": "icloud.com",
  "btinternt.com": "btinternet.com", "btinterent.com": "btinternet.com", "btinternet.co": "btinternet.com", "live.co": "live.co.uk",
  "sky.con": "sky.com", "aol.co": "aol.com",
};
const TLD_TYPOS = [[".con", ".com"], [".cmo", ".com"], [".comm", ".com"], [".c0m", ".com"], [".co.uj", ".co.uk"], [".co.k", ".co.uk"], [".couk", ".co.uk"]];

export function emailSuggestion(email) {
  const v = (email || "").trim().toLowerCase();
  const i = v.lastIndexOf("@");
  if (i < 1 || i === v.length - 1) return null;
  const local = v.slice(0, i);
  const domain = v.slice(i + 1);
  let fixed = DOMAIN_TYPOS[domain];
  if (!fixed) {
    const t = TLD_TYPOS.find(([bad]) => domain.endsWith(bad));
    if (t) fixed = domain.slice(0, -t[0].length) + t[1];
  }
  return fixed ? { domain: fixed, email: `${local}@${fixed}` } : null;
}
